
import { getAllCoaches, getCoachById } from './coachFetchOperations';
import { updateCoach, deleteCoach } from './coachMutationOperations';

// Create and export the coachOperations function needed by the store
export const createCoachOperations = (set: any, get: any) => ({
  fetchCoaches: async () => {
    set({ isLoading: true, error: null });
    try {
      const coaches = await getAllCoaches();
      set({ coaches, isLoading: false });
    } catch (error) {
      console.error('Error fetching coaches:', error);
      set({ error: 'Failed to fetch coaches', isLoading: false });
    }
  },
  
  fetchCoachById: async (id: string) => {
    set({ isLoading: true, error: null });
    try {
      const coach = await getCoachById(id);
      set({ selectedCoach: coach, isLoading: false });
    } catch (error) {
      console.error('Error fetching coach by ID:', error);
      set({ error: 'Failed to fetch coach', isLoading: false });
    }
  },
  
  
  updateCoach: async (id: string, updates: Partial<CoachModel>) => {
    set({ isLoading: true, error: null });
    try {
      const state = get();
      const success = await updateCoach(id, updates, state);
      
      if (success) {
        // Refresh the coaches list
        const coaches = await getAllCoaches();
        set({ coaches, isLoading: false });
      } else {
        set({ error: 'Failed to update coach', isLoading: false });
      }
      
      return success;
    } catch (error) {
      console.error('Error in updateCoach operation:', error);
      set({ error: 'Failed to update coach', isLoading: false });
      return false;
    }
  },
  
  toggleCoachStatus: async (id: string) => {
    set({ isLoading: true, error: null });
    try {
      const state = get();
      const coach = state.coaches.find(c => c.id === id);
      
      if (!coach) {
        set({ error: 'Coach not found', isLoading: false });
        return false;
      }
      
      const newStatus = coach.status === 'active' ? 'inactive' : 'active';
      const success = await updateCoach(id, { status: newStatus }, state);
      
      if (success) {
        // Refresh the coaches list
        const coaches = await getAllCoaches();
        set({ coaches, isLoading: false });
      } else {
        set({ error: 'Failed to toggle coach status', isLoading: false });
      }
      
      return success;
    } catch (error) {
      console.error('Error in toggleCoachStatus operation:', error);
      set({ error: 'Failed to toggle coach status', isLoading: false });
      return false;
    }
  }
});

// Need to import CoachModel for TypeScript
import { CoachModel } from './types';
